import BaseContainer from './BaseContainer';
const GlobalJitaContainer = BaseContainer.create('GlobalJitaContainer');
export default GlobalJitaContainer;